import { render, staticRenderFns } from "./ItsOrderInBoundVar.vue?vue&type=template&id=21cb052a&scoped=true&"
import script from "./ItsOrderInBoundVar.vue?vue&type=script&lang=js&"
export * from "./ItsOrderInBoundVar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cb052a",
  null
  
)

export default component.exports